import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';

import { endpoints } from 'global/endpoints';
import { useTimeClockStore } from 'store/useTimeClockStore';
import http from 'utils/http';

type ClockInResponse = {
  payload: any;
};

export const checkClockIn = (): Promise<ClockInResponse> => {
  const newEndpoints = endpoints.timeClock.checkClockIn;
  return http().get(newEndpoints);
};

export function useCheckClockIn(): UseQueryResult<ClockInResponse, unknown> {
  const addTimeClockDetails = useTimeClockStore(state => state.addTimeClockDetails);

  const queryResult = useQuery<ClockInResponse, unknown>({
    queryKey: ['checkClockIn'],
    queryFn: () => checkClockIn(),
  });

  // Handle side effects when data is successfully fetched
  useEffect(() => {
    if (queryResult.isSuccess) {
      if (queryResult?.data?.payload) {
        addTimeClockDetails(queryResult?.data?.payload);
      } else {
        addTimeClockDetails(null);
      }
    }

    if (queryResult.isError) {
      addTimeClockDetails(null);
    }
  }, [queryResult.isSuccess, queryResult.isError, queryResult.data, addTimeClockDetails]);

  return queryResult;
}
